const API = 'UserPatientProfileWeeklyReportActivities';

export const API_USER_PATIENT_PROFILE_WEEKLY_REPORT_ACTIVITIES = {
  GET_ALL_DYNAMIC: `${API}/GetAllDynamic`,
  POST: `${API}/Create`,
  PATCH: (data: Pick<Components.Schemas.UserPatientProfileWeeklyReportActivity, 'id'>) =>
    `${API}/Patch/${data.id}`,
  DELETE: (data: Pick<Components.Schemas.UserPatientProfileWeeklyReportActivity, 'id'>) =>
    `${API}/Delete/${data.id}`,
};
export interface AppUserPatientProfileWeeklyReportActivity
  extends Omit<
    Components.Schemas.UserPatientProfileWeeklyReportActivity,
    'alertSubscriptionDiff' | 'alertMonthDiff'
  > {
  alertSubscriptionDiff?: AlertWeight;
  alertMonthDiff?: AlertWeight;
}

export enum AlertWeight {
  NotLosingWeight = 1,
  SlowWeight,
  GoodWeight
}
